import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex p-jc-end p-pr-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "h3 p-pl-3" }, "Vigentes", -1)
const _hoisted_3 = { class: "p-mt-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "h3 p-pl-3" }, "A expirar", -1)
const _hoisted_5 = { class: "p-mt-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "h3 p-pl-3" }, "Archivados", -1)
const _hoisted_7 = { class: "p-pl-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_SyllabumTable = _resolveComponent("SyllabumTable")!
  const _component_SyllabusSelector = _resolveComponent("SyllabusSelector")!
  const _component_NewSyllabusModal = _resolveComponent("NewSyllabusModal")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.displayNewSyllabusModal = !_ctx.displayNewSyllabusModal)),
        class: "p-button-outlined",
        label: "Nuevo programa"
      })
    ]),
    _createElementVNode("div", null, [
      _hoisted_2,
      _createVNode(_component_SyllabumTable, {
        loading: _ctx.loadingSyllabum,
        onNewVersion: _ctx.openNewSyllabusModalWithDefaultFields,
        onDeleteVersion: _ctx.showConfirmDeleteVersion,
        onTogglePublished: _ctx.togglePublished,
        syllabum: _ctx.syllabumLastVersions
      }, null, 8, ["loading", "onNewVersion", "onDeleteVersion", "onTogglePublished", "syllabum"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_SyllabumTable, {
        loading: _ctx.loadingSyllabum,
        syllabum: _ctx.syllabumExpiring,
        isExpiringTable: true
      }, null, 8, ["loading", "syllabum"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_SyllabusSelector, {
          onClick: _ctx.fetchArchivedSyllabum,
          onClickOnVersion: _ctx.goToSyllabusDetail,
          loading: _ctx.loadingArchived,
          syllabum: _ctx.syllabumArchived,
          placeholder: "Ver archivados",
          deleteValueAfterSelect: true
        }, null, 8, ["onClick", "onClickOnVersion", "loading", "syllabum"])
      ])
    ]),
    _createVNode(_component_NewSyllabusModal, {
      visible: _ctx.displayNewSyllabusModal,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.displayNewSyllabusModal = $event)),
      defaultFields: _ctx.syllabusLastVersionCreated,
      "onUpdate:defaultFields": _cache[2] || (_cache[2] = ($event: any) => (_ctx.syllabusLastVersionCreated = $event)),
      onSubmitNewSyllabus: _ctx.assignVersionAndCreate,
      onCleanFields: _cache[3] || (_cache[3] = ($event: any) => (_ctx.cleanSyllabusModalFields()))
    }, null, 8, ["visible", "defaultFields", "onSubmitNewSyllabus"]),
    _createVNode(_component_ConfirmDialog, {
      breakpoints: {'960px': '75vw', '640px': '100vw'},
      style: {width: '50vw'}
    })
  ], 64))
}